import * as Yup from 'yup';

import { ClaimRejectedStatus, ClaimStatus } from '../constants';

export const getClaimOverviewStatusSchema = (selectedStatus: string) =>
  Yup.object().shape({
    reason_for_rejection: Yup.string().when('status', {
      is: () => Object.values(ClaimRejectedStatus).some((status) => status === selectedStatus),
      then: () => Yup.string().trim().required(),
      otherwise: () => Yup.string().nullable(),
    }),
    date_primary_approved: Yup.string().when('status', {
      is: (val: string) => val === ClaimStatus.APPROVED,
      then: () => Yup.string().trim().required(),
      otherwise: () => Yup.string().nullable(),
    }),
    date_rejected: Yup.string().when('status', {
      is: () => Object.values(ClaimRejectedStatus).some((status) => status === selectedStatus),
      then: () => Yup.string().trim().required(),
      otherwise: () => Yup.string().nullable(),
    }),
    status: Yup.string().trim().required(),
  });

export const getSecondaryClaimStatusSchema = (selectedStatus: string) =>
  Yup.object().shape({
    secondary_reason_for_rejection: Yup.string().when('secondary_status', {
      is: () => Object.values(ClaimRejectedStatus).some((status) => status === selectedStatus),
      then: () => Yup.string().trim().required(),
      otherwise: () => Yup.string().nullable(),
    }),
    date_secondary_approved: Yup.string().when('secondary_status', {
      is: (val: string) => val === ClaimStatus.APPROVED,
      then: () => Yup.string().trim().required(),
      otherwise: () => Yup.string().nullable(),
    }),
    date_secondary_payor_rejected: Yup.string().when('secondary_status', {
      is: () => Object.values(ClaimRejectedStatus).some((status) => status === selectedStatus),
      then: () => Yup.string().trim().required(),
      otherwise: () => Yup.string().nullable(),
    }),
    secondary_status: Yup.string().trim().required(),
  });
